package com.devi3east.bashbuddy.ktor.stripe.ui

import com.devi3east.bashbuddy.account.organization.domain.models.StripeAccount

data class StripeUiState(
    val isLoading: Boolean = false,
    val errorMessage: String? = null,
    val accountId: String? = null,
    val onboardingUrl: String? = null,
    val dashboardUrl: String? = null,
    val onboardingComplete: Boolean = false,
    val currentlyDue: List<String> = emptyList(),
    val eventuallyDue: List<String> = emptyList()
) {
    fun toStripeAccount(): StripeAccount? {
        return accountId?.let {
            StripeAccount(
                accountId = it,
                onboardingComplete = onboardingComplete,
                currentlyDue = currentlyDue,
                eventuallyDue = eventuallyDue
            )
        }
    }
}